import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    document.addEventListener("click", this.outsideClickHandler);
    document.addEventListener("keydown", this.keydownHandler);
    document.addEventListener("turbo:before-cache", this.teardownHandler);
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickHandler);
    document.removeEventListener("keydown", this.keydownHandler);
    document.removeEventListener("turbo:before-cache", this.teardownHandler);
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.menuTarget.classList.contains("hidden")) {
      this.showMenu();
    } else {
      this.hideMenu();
    }
  }

  showMenu() {
    this.menuTarget.classList.remove("hidden");
  }

  hideMenu() {
    this.menuTarget.classList.add("hidden");
  }

  outsideClickHandler = (event) => {
    if (
      !this.element.contains(event.target) &&
      !this.menuTarget.classList.contains("hidden")
    ) {
      this.hideMenu();
    }
  };

  keydownHandler = (event) => {
    if (
      event.key === "Escape" &&
      !this.menuTarget.classList.contains("hidden")
    ) {
      this.hideMenu();
    }
  };

  teardownHandler = () => {
    this.hideMenu();
  };
}
